var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('img',{attrs:{"src":require(("@/assets/home/icons/" + _vm.icon + ".svg")),"alt":"no image"}})]),_c('h5',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.titre)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }